<template>
  <svg
    width="520"
    height="300"
    viewBox="0 0 520 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="520"
      height="299"
      transform="translate(0 0.799805)"
      fill="white"
    />
    <rect
      width="437.45"
      height="1.3"
      transform="translate(51.3499 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="437.45"
      height="1.3"
      transform="translate(51.3499 71.0005)"
      fill="#EAECF0"
    />
    <rect
      width="437.45"
      height="1.3"
      transform="translate(51.3499 115.2)"
      fill="#EAECF0"
    />
    <rect
      width="437.45"
      height="1.3"
      transform="translate(51.3499 159.4)"
      fill="#EAECF0"
    />
    <rect
      width="437.45"
      height="1.3"
      transform="translate(51.3499 203.6)"
      fill="#EAECF0"
    />
    <rect
      width="437.45"
      height="1.3"
      transform="translate(51.3499 247.8)"
      fill="#EAECF0"
    />
    <rect
      width="1.3"
      height="222.3"
      transform="translate(50.0498 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(114.4 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(176.981 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(239.563 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(302.688 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(365.27 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(427.851 26.8003)"
      fill="#EAECF0"
    />
    <rect
      width="1.08837"
      height="222.3"
      transform="translate(487.711 26.8003)"
      fill="#EAECF0"
    />
    <path
      d="M37.4694 27.6711V28.25H33.8398V27.7435L35.6565 25.7211C35.8799 25.4723 36.0526 25.2615 36.1745 25.0889C36.2989 24.9137 36.3852 24.7575 36.4334 24.6204C36.4842 24.4808 36.5096 24.3386 36.5096 24.1938C36.5096 24.011 36.4715 23.846 36.3954 23.6987C36.3217 23.5489 36.2125 23.4296 36.0678 23.3407C35.9231 23.2519 35.7479 23.2074 35.5422 23.2074C35.2959 23.2074 35.0903 23.2557 34.9252 23.3521C34.7627 23.4461 34.6409 23.5781 34.5596 23.7482C34.4784 23.9184 34.4377 24.1139 34.4377 24.3348H33.7332C33.7332 24.0225 33.8017 23.7368 33.9388 23.4778C34.0759 23.2188 34.2791 23.0132 34.5482 22.8608C34.8173 22.706 35.1487 22.6285 35.5422 22.6285C35.8926 22.6285 36.1922 22.6907 36.4411 22.8151C36.6899 22.937 36.8803 23.1097 37.0124 23.3331C37.1469 23.554 37.2142 23.813 37.2142 24.1101C37.2142 24.2726 37.1863 24.4376 37.1304 24.6052C37.0771 24.7702 37.0022 24.9353 36.9057 25.1003C36.8118 25.2653 36.7013 25.4278 36.5744 25.5878C36.45 25.7478 36.3166 25.9052 36.1745 26.0601L34.6891 27.6711H37.4694ZM39.1147 25.6106L38.551 25.4659L38.8291 22.7047H41.6741V23.356H39.427L39.2594 24.8642C39.361 24.8058 39.4892 24.7512 39.6441 24.7004C39.8015 24.6496 39.9818 24.6242 40.1849 24.6242C40.4414 24.6242 40.6711 24.6687 40.8743 24.7575C41.0774 24.8438 41.25 24.9683 41.3922 25.1308C41.537 25.2933 41.6474 25.4888 41.7236 25.7173C41.7998 25.9458 41.8378 26.201 41.8378 26.4828C41.8378 26.7494 41.801 26.9944 41.7274 27.2179C41.6563 27.4413 41.5484 27.6368 41.4037 27.8044C41.2589 27.9694 41.0761 28.0977 40.8552 28.1891C40.6369 28.2805 40.3792 28.3262 40.0821 28.3262C39.8586 28.3262 39.6466 28.2957 39.446 28.2348C39.248 28.1713 39.0703 28.0761 38.9128 27.9491C38.758 27.8196 38.631 27.6597 38.532 27.4692C38.4355 27.2763 38.3746 27.0503 38.3492 26.7913H39.0195C39.05 26.9995 39.1109 27.1747 39.2023 27.3169C39.2937 27.4591 39.413 27.567 39.5603 27.6406C39.7101 27.7117 39.884 27.7473 40.0821 27.7473C40.2497 27.7473 40.3982 27.7181 40.5277 27.6597C40.6572 27.6013 40.7664 27.5175 40.8552 27.4083C40.9441 27.2991 41.0114 27.1671 41.0571 27.0122C41.1053 26.8573 41.1294 26.6834 41.1294 26.4904C41.1294 26.3152 41.1053 26.1527 41.0571 26.0029C41.0088 25.8531 40.9365 25.7224 40.84 25.6106C40.746 25.4989 40.6305 25.4126 40.4934 25.3517C40.3563 25.2882 40.1989 25.2564 40.0211 25.2564C39.785 25.2564 39.606 25.2882 39.4841 25.3517C39.3648 25.4151 39.2417 25.5015 39.1147 25.6106Z"
      fill="#475467"
    />
    <path
      d="M37.4694 71.8713V72.4502H33.8398V71.9437L35.6565 69.9213C35.8799 69.6725 36.0526 69.4617 36.1745 69.2891C36.2989 69.1139 36.3852 68.9577 36.4334 68.8206C36.4842 68.681 36.5096 68.5388 36.5096 68.394C36.5096 68.2112 36.4715 68.0462 36.3954 67.8989C36.3217 67.7491 36.2125 67.6298 36.0678 67.5409C35.9231 67.4521 35.7479 67.4076 35.5422 67.4076C35.2959 67.4076 35.0903 67.4559 34.9252 67.5523C34.7627 67.6463 34.6409 67.7783 34.5596 67.9484C34.4784 68.1186 34.4377 68.3141 34.4377 68.535H33.7332C33.7332 68.2227 33.8017 67.937 33.9388 67.678C34.0759 67.419 34.2791 67.2134 34.5482 67.061C34.8173 66.9062 35.1487 66.8287 35.5422 66.8287C35.8926 66.8287 36.1922 66.8909 36.4411 67.0153C36.6899 67.1372 36.8803 67.3099 37.0124 67.5333C37.1469 67.7542 37.2142 68.0132 37.2142 68.3103C37.2142 68.4728 37.1863 68.6378 37.1304 68.8054C37.0771 68.9704 37.0022 69.1354 36.9057 69.3005C36.8118 69.4655 36.7013 69.628 36.5744 69.788C36.45 69.9479 36.3166 70.1054 36.1745 70.2603L34.6891 71.8713H37.4694ZM41.7045 69.2357V70.0812C41.7045 70.5357 41.6639 70.9191 41.5827 71.2314C41.5014 71.5437 41.3846 71.7951 41.2323 71.9855C41.0799 72.176 40.8958 72.3144 40.68 72.4007C40.4667 72.4845 40.2255 72.5264 39.9564 72.5264C39.7431 72.5264 39.5463 72.4997 39.3661 72.4464C39.1858 72.3931 39.0233 72.308 38.8786 72.1912C38.7364 72.0719 38.6145 71.917 38.5129 71.7266C38.4114 71.5361 38.3339 71.3051 38.2806 71.0334C38.2273 70.7617 38.2006 70.4443 38.2006 70.0812V69.2357C38.2006 68.7812 38.2413 68.4004 38.3225 68.0932C38.4063 67.7859 38.5244 67.5396 38.6767 67.3543C38.8291 67.1664 39.0119 67.0318 39.2251 66.9506C39.441 66.8693 39.6822 66.8287 39.9488 66.8287C40.1646 66.8287 40.3626 66.8554 40.5429 66.9087C40.7257 66.9595 40.8882 67.042 41.0304 67.1562C41.1726 67.268 41.2932 67.4178 41.3922 67.6057C41.4938 67.791 41.5712 68.0183 41.6246 68.2874C41.6779 68.5565 41.7045 68.8727 41.7045 69.2357ZM40.9961 70.1955V69.1177C40.9961 68.8688 40.9809 68.6505 40.9504 68.4626C40.9225 68.2722 40.8806 68.1097 40.8248 67.9751C40.7689 67.8405 40.6978 67.7313 40.6115 67.6476C40.5277 67.5638 40.4299 67.5028 40.3182 67.4647C40.209 67.4241 40.0859 67.4038 39.9488 67.4038C39.7812 67.4038 39.6327 67.4355 39.5032 67.499C39.3737 67.56 39.2645 67.6577 39.1756 67.7923C39.0893 67.9269 39.0233 68.1033 38.9776 68.3217C38.9319 68.54 38.909 68.8054 38.909 69.1177V70.1955C38.909 70.4443 38.923 70.664 38.9509 70.8544C38.9814 71.0448 39.0258 71.2099 39.0842 71.3495C39.1426 71.4866 39.2137 71.5996 39.2975 71.6885C39.3813 71.7773 39.4778 71.8434 39.587 71.8865C39.6987 71.9271 39.8218 71.9475 39.9564 71.9475C40.1291 71.9475 40.2801 71.9145 40.4096 71.8484C40.5391 71.7824 40.647 71.6796 40.7333 71.5399C40.8222 71.3978 40.8882 71.2162 40.9314 70.9953C40.9746 70.7719 40.9961 70.5053 40.9961 70.1955Z"
      fill="#475467"
    />
    <path
      d="M36.1516 111.074V116.65H35.447V111.954L34.0264 112.472V111.836L36.0412 111.074H36.1516ZM39.1147 114.011L38.551 113.866L38.8291 111.105H41.6741V111.756H39.427L39.2594 113.264C39.361 113.206 39.4892 113.151 39.6441 113.1C39.8015 113.05 39.9818 113.024 40.1849 113.024C40.4414 113.024 40.6711 113.069 40.8743 113.157C41.0774 113.244 41.25 113.368 41.3922 113.531C41.537 113.693 41.6474 113.889 41.7236 114.117C41.7998 114.346 41.8378 114.601 41.8378 114.883C41.8378 115.149 41.801 115.394 41.7274 115.618C41.6563 115.841 41.5484 116.037 41.4037 116.204C41.2589 116.369 41.0761 116.498 40.8552 116.589C40.6369 116.68 40.3792 116.726 40.0821 116.726C39.8586 116.726 39.6466 116.696 39.446 116.635C39.248 116.571 39.0703 116.476 38.9128 116.349C38.758 116.22 38.631 116.06 38.532 115.869C38.4355 115.676 38.3746 115.45 38.3492 115.191H39.0195C39.05 115.399 39.1109 115.575 39.2023 115.717C39.2937 115.859 39.413 115.967 39.5603 116.041C39.7101 116.112 39.884 116.147 40.0821 116.147C40.2497 116.147 40.3982 116.118 40.5277 116.06C40.6572 116.001 40.7664 115.917 40.8552 115.808C40.9441 115.699 41.0114 115.567 41.0571 115.412C41.1053 115.257 41.1294 115.083 41.1294 114.89C41.1294 114.715 41.1053 114.553 41.0571 114.403C41.0088 114.253 40.9365 114.122 40.84 114.011C40.746 113.899 40.6305 113.812 40.4934 113.752C40.3563 113.688 40.1989 113.656 40.0211 113.656C39.785 113.656 39.606 113.688 39.4841 113.752C39.3648 113.815 39.2417 113.901 39.1147 114.011Z"
      fill="#475467"
    />
    <path
      d="M36.1516 155.274V160.85H35.447V156.154L34.0264 156.672V156.036L36.0412 155.274H36.1516ZM41.7045 157.636V158.481C41.7045 158.936 41.6639 159.319 41.5827 159.631C41.5014 159.944 41.3846 160.195 41.2323 160.385C41.0799 160.576 40.8958 160.714 40.68 160.801C40.4667 160.884 40.2255 160.926 39.9564 160.926C39.7431 160.926 39.5463 160.9 39.3661 160.846C39.1858 160.793 39.0233 160.708 38.8786 160.591C38.7364 160.472 38.6145 160.317 38.5129 160.126C38.4114 159.936 38.3339 159.705 38.2806 159.433C38.2273 159.162 38.2006 158.844 38.2006 158.481V157.636C38.2006 157.181 38.2413 156.8 38.3225 156.493C38.4063 156.186 38.5244 155.94 38.6767 155.754C38.8291 155.566 39.0119 155.432 39.2251 155.35C39.441 155.269 39.6822 155.229 39.9488 155.229C40.1646 155.229 40.3626 155.255 40.5429 155.309C40.7257 155.359 40.8882 155.442 41.0304 155.556C41.1726 155.668 41.2932 155.818 41.3922 156.006C41.4938 156.191 41.5712 156.418 41.6246 156.687C41.6779 156.956 41.7045 157.273 41.7045 157.636ZM40.9961 158.595V157.518C40.9961 157.269 40.9809 157.05 40.9504 156.862C40.9225 156.672 40.8806 156.51 40.8248 156.375C40.7689 156.24 40.6978 156.131 40.6115 156.047C40.5277 155.964 40.4299 155.903 40.3182 155.865C40.209 155.824 40.0859 155.804 39.9488 155.804C39.7812 155.804 39.6327 155.835 39.5032 155.899C39.3737 155.96 39.2645 156.058 39.1756 156.192C39.0893 156.327 39.0233 156.503 38.9776 156.722C38.9319 156.94 38.909 157.205 38.909 157.518V158.595C38.909 158.844 38.923 159.064 38.9509 159.254C38.9814 159.445 39.0258 159.61 39.0842 159.749C39.1426 159.887 39.2137 160 39.2975 160.088C39.3813 160.177 39.4778 160.243 39.587 160.286C39.6987 160.327 39.8218 160.347 39.9564 160.347C40.1291 160.347 40.2801 160.314 40.4096 160.248C40.5391 160.182 40.647 160.079 40.7333 159.94C40.8222 159.798 40.8882 159.616 40.9314 159.395C40.9746 159.172 40.9961 158.905 40.9961 158.595Z"
      fill="#475467"
    />
    <path
      d="M39.6647 202.41L39.1011 202.266L39.3791 199.504H42.2241V200.156H39.9771L39.8095 201.664C39.911 201.606 40.0393 201.551 40.1941 201.5C40.3516 201.449 40.5318 201.424 40.735 201.424C40.9914 201.424 41.2212 201.468 41.4243 201.557C41.6274 201.644 41.8001 201.768 41.9423 201.931C42.087 202.093 42.1975 202.289 42.2736 202.517C42.3498 202.746 42.3879 203.001 42.3879 203.283C42.3879 203.549 42.3511 203.794 42.2774 204.018C42.2063 204.241 42.0984 204.437 41.9537 204.604C41.809 204.769 41.6262 204.897 41.4053 204.989C41.1869 205.08 40.9292 205.126 40.6321 205.126C40.4087 205.126 40.1967 205.096 39.9961 205.035C39.798 204.971 39.6203 204.876 39.4629 204.749C39.308 204.619 39.1811 204.459 39.082 204.269C38.9855 204.076 38.9246 203.85 38.8992 203.591H39.5695C39.6 203.799 39.6609 203.975 39.7523 204.117C39.8437 204.259 39.9631 204.367 40.1104 204.44C40.2602 204.512 40.4341 204.547 40.6321 204.547C40.7997 204.547 40.9482 204.518 41.0777 204.459C41.2072 204.401 41.3164 204.317 41.4053 204.208C41.4941 204.099 41.5614 203.967 41.6071 203.812C41.6554 203.657 41.6795 203.483 41.6795 203.29C41.6795 203.115 41.6554 202.953 41.6071 202.803C41.5589 202.653 41.4865 202.522 41.39 202.41C41.2961 202.299 41.1806 202.212 41.0435 202.151C40.9063 202.088 40.7489 202.056 40.5712 202.056C40.3351 202.056 40.1561 202.088 40.0342 202.151C39.9148 202.215 39.7917 202.301 39.6647 202.41Z"
      fill="#475467"
    />
    <path
      d="M42.2546 246.036V246.881C42.2546 247.336 42.214 247.719 42.1327 248.031C42.0515 248.344 41.9347 248.595 41.7823 248.785C41.63 248.976 41.4459 249.114 41.2301 249.2C41.0168 249.284 40.7756 249.326 40.5064 249.326C40.2932 249.326 40.0964 249.3 39.9161 249.246C39.7358 249.193 39.5733 249.108 39.4286 248.991C39.2864 248.872 39.1646 248.717 39.063 248.526C38.9614 248.336 38.884 248.105 38.8307 247.833C38.7773 247.562 38.7507 247.244 38.7507 246.881V246.036C38.7507 245.581 38.7913 245.2 38.8726 244.893C38.9563 244.586 39.0744 244.339 39.2268 244.154C39.3791 243.966 39.5619 243.832 39.7752 243.75C39.991 243.669 40.2322 243.629 40.4988 243.629C40.7146 243.629 40.9127 243.655 41.093 243.708C41.2758 243.759 41.4383 243.842 41.5805 243.956C41.7227 244.068 41.8433 244.218 41.9423 244.405C42.0438 244.591 42.1213 244.818 42.1746 245.087C42.2279 245.356 42.2546 245.672 42.2546 246.036ZM41.5462 246.995V245.917C41.5462 245.669 41.531 245.45 41.5005 245.262C41.4726 245.072 41.4307 244.909 41.3748 244.775C41.3189 244.64 41.2479 244.531 41.1615 244.447C41.0777 244.364 40.98 244.303 40.8683 244.265C40.7591 244.224 40.6359 244.204 40.4988 244.204C40.3312 244.204 40.1827 244.235 40.0532 244.299C39.9237 244.36 39.8146 244.458 39.7257 244.592C39.6394 244.727 39.5733 244.903 39.5276 245.121C39.4819 245.34 39.4591 245.605 39.4591 245.917V246.995C39.4591 247.244 39.473 247.464 39.501 247.654C39.5314 247.845 39.5759 248.01 39.6343 248.149C39.6927 248.286 39.7638 248.399 39.8476 248.488C39.9313 248.577 40.0278 248.643 40.137 248.686C40.2487 248.727 40.3719 248.747 40.5064 248.747C40.6791 248.747 40.8302 248.714 40.9597 248.648C41.0892 248.582 41.1971 248.479 41.2834 248.34C41.3723 248.198 41.4383 248.016 41.4814 247.795C41.5246 247.572 41.5462 247.305 41.5462 246.995Z"
      fill="#475467"
    />
    <circle cx="52.6501" cy="204.9" r="3.25" fill="#9A8AC2" />
    <circle cx="115.05" cy="186.05" r="3.25" fill="#9A8AC2" />
    <circle cx="177.45" cy="167.2" r="3.25" fill="#9A8AC2" />
    <circle cx="239.85" cy="149" r="3.25" fill="#9A8AC2" />
    <circle cx="303.55" cy="130.15" r="3.25" fill="#9A8AC2" />
    <circle cx="365.95" cy="111.3" r="3.25" fill="#9A8AC2" />
    <circle cx="428.35" cy="93.0996" r="3.25" fill="#9A8AC2" />
    <circle cx="488.15" cy="75.5498" r="3.25" fill="#9A8AC2" />
    <path
      d="M52.6501 204.9L488.15 75.5498"
      stroke="#9A8AC2"
      stroke-width="1.3"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(42.25 257.55)"
      fill="white"
    />
    <rect
      x="42.25"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="47.45"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(103.629 257.55)"
      fill="white"
    />
    <rect
      x="103.629"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="108.829"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(165.007 257.55)"
      fill="white"
    />
    <rect
      x="165.007"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="170.207"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(226.386 257.55)"
      fill="white"
    />
    <rect
      x="226.386"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="231.586"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(287.764 257.55)"
      fill="white"
    />
    <rect
      x="287.764"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="292.964"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(349.143 257.55)"
      fill="white"
    />
    <rect
      x="349.143"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="354.343"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(410.521 257.55)"
      fill="white"
    />
    <rect
      x="410.521"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="415.721"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      width="32.5"
      height="20.8"
      transform="translate(471.9 257.55)"
      fill="white"
    />
    <rect
      x="471.9"
      y="260.15"
      width="32.5"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
    <rect
      x="477.1"
      y="270.55"
      width="22.1"
      height="5.2"
      rx="2.6"
      fill="#EAECF0"
    />
  </svg>
</template>

<script>
export default {
  name: "ExampleCumulative"
};
</script>



// WEBPACK FOOTER //
// src/components/clients/report/ExampleCumulative.vue